// extracted by mini-css-extract-plugin
export var topImg = "bordered-list-module--top-img--24c75";